import styled from '@emotion/styled';
const Radio = styled.div<{
  active: boolean;
  size: number;
}>`
  display: flex;
  min-width: ${({
  size
}) => size}px;
  width: ${({
  size
}) => size}px;
  height: ${({
  size
}) => size}px;
  box-sizing: border-box;
  border-width: 2px;
  border-style: solid;
  position: relative;
  border-radius: ${({
  size
}) => size}px;
  border-color: ${({
  theme
}) => theme.color.content12};
  color: ${({
  theme
}) => theme.color.accentH1};

  ${({
  theme,
  active,
  size
}) => active && `
      border-width: 2px;
      border-color: currentColor;
      &:after {
        color: inherit;
        border-radius: ${size}px;
        content: "";
        position: absolute;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 4px solid ${theme.color.surface2};
        background-color: currentColor;
      }
    `};
`;
export default Radio;